import React from 'react';
import _ from 'lodash';

import {Pagination, PaginationItem, PaginationLink} from 'reactstrap';

class Pager extends React.Component {
    render() {
        const {pageSize, total, skip, onPageSelected} = this.props;

        if (total === void 0) {
            return null;
        }

        const pageIndex = (skip / pageSize);
        const lowerIndex = (pageIndex - 20) < 0 ? 0 : pageIndex - 20;
        const upperIndex = pageIndex + 20;

        const pages = [];
        let index = 0;
        for (let s = 0; s < total; s += pageSize) {
            if (index >= lowerIndex && index <= upperIndex) {
                pages.push({
                    skip: s,
                    index,
                    number: index + 1,
                    current: s === skip
                });
            }

            index++;
        }

        if (pages.length <= 1) {
            return null;
        }

        const pageLinks = _.map(pages, page => {
                return page.current
                    ? <PaginationItem key={page.index} active>
                        <PaginationLink href="javascript://">
                            {page.number} <span className="sr-only">(current)</span>
                        </PaginationLink>
                    </PaginationItem>
                    : <PaginationItem key={page.index}>
                        <PaginationLink id={`LinkPager_${page.number}`} href="javascript://"
                                        onClick={() => onPageSelected(page.skip)}>
                            {page.number}
                        </PaginationLink>
                    </PaginationItem>
            }
        );

        const selectedIndex = _.indexOf(pages, skip);

        const prevLink = selectedIndex === 0
            ? <PaginationItem>
                <PaginationLink previous disabled/>
            </PaginationItem>
            : <PaginationItem>
                <PaginationLink previous id="LinkPagerPrevious" href="javascript://" aria-label="Previous"
                                onClick={() => onPageSelected(pages[selectedIndex - 1])}/>
            </PaginationItem>
        ;

        const nextLink = selectedIndex === (pages.length - 1)
            ? <PaginationItem>
                <PaginationLink next disbaled/>
            </PaginationItem>
            : <PaginationItem>
                <PaginationLink next id="LinkPagerNext" href="javascript://" aria-label="Next"
                                onClick={() => onPageSelected(pages[selectedIndex + 1])}/>
            </PaginationItem>
        ;

        return <div className="text-center">
            <nav aria-label="Page navigation">
                <br/>
                <Pagination aria-label="Page navigation example">
                    {prevLink}
                    {pageLinks}
                    {nextLink}
                </Pagination>
            </nav>
        </div>;
    }
}

export default Pager;